import { BASE_URL } from "../configs";
import axiosInstance from "./axios"


export async function deleteProjectEquipment(id) {
    let url = `${BASE_URL}/api/project-equipment/${id}`;

    const res = await axiosInstance.delete(url)
    return res.data.Data;
}
